import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36eed53c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "sr-only" })
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "row"
}
const _hoisted_5 = { class: "col-12 text-end fst-italic" }
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "col" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col fw-bold" }, " Valgte rækker ")
], -1))
const _hoisted_9 = {
  key: 0,
  class: "row"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, " Ingen valgt ", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "row border-bottom"
}
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "table table-sm table-striped" }
const _hoisted_15 = { class: "col-12 text-end fst-italic" }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "table table-sm table-striped" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "col-12" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col" }
const _hoisted_22 = { "aria-label": "navigation" }
const _hoisted_23 = { class: "pagination justify-content-center" }
const _hoisted_24 = ["disabled", "onClick", "innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.rows.length > 0 && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.multiple)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    (!_ctx.selected)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                      : _createCommentVNode("", true),
                    (_ctx.selected)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("table", _hoisted_14, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getRow(_ctx.selected[0] as string), (colummn, columnIndex) => {
                                    return (_openBlock(), _createElementBlock("th", { key: columnIndex }, _toDisplayString(columnIndex), 1))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selected, (rowData, rowIndex) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: rowIndex }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getRow(rowData as string), (colummn, columnIndex) => {
                                      return (_openBlock(), _createElementBlock("td", { key: columnIndex }, _toDisplayString(colummn), 1))
                                    }), 128))
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.results.from) + " - " + _toDisplayString(_ctx.results.to) + " af " + _toDisplayString(_ctx.results.total) + " resultater ", 1),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("table", _hoisted_17, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows[0], (colummn, columnIndex) => {
                    return (_openBlock(), _createElementBlock("th", { key: columnIndex }, _toDisplayString(columnIndex), 1))
                  }), 128))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (rowData, rowIndex) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: _normalizeClass(_ctx.isSelected(rowData) ? 'text-bg-info' : ''),
                    key: rowIndex,
                    onClick: ($event: any) => (_ctx.selectRow(rowIndex, rowData))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowData, (colummn, columnIndex) => {
                      return (_openBlock(), _createElementBlock("td", { key: columnIndex }, _toDisplayString(colummn), 1))
                    }), 128))
                  ], 10, _hoisted_18))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("nav", _hoisted_22, [
                  _createElementVNode("ul", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results.links, (link, linkIndex) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "page-item",
                        key: linkIndex
                      }, [
                        _createElementVNode("button", {
                          disabled: !link.url || link.active,
                          class: _normalizeClass([link.active ? 'fw-bold' : 'text-decoration-underline', "btn btn-link"]),
                          onClick: ($event: any) => (_ctx.changePage(link)),
                          innerHTML: link.label
                        }, null, 10, _hoisted_24)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}